module.exports = __webpack_public_path__ + "img/bg-2.6c55875f.jpg";